import { DepressionContentPage } from "@/components/DepressionContentPage";
import { allTmsByConditionLinks } from "@/components/RelatedPages";

const TmsCoralSpringsFl = () => (
  <DepressionContentPage
    seo={{
      title: "TMS Therapy Coral Springs, FL | Neuro Wellness TMS",
      description:
        "TMS, SAINT®, SPRAVATO®, and ketamine treatment in Coral Springs, FL. Serving Broward, Miami-Dade, and Palm Beach counties. Schedule a consultation today.",
      canonical: "/tms-coral-springs-fl",
      keywords:
        "TMS Coral Springs FL, TMS treatment Coral Springs, depression treatment Coral Springs, SAINT Coral Springs, Neuro Wellness",
    }}
    badge="Coral Springs, FL"
    heroTitle="TMS Treatment in Coral Springs, Florida"
    heroSubtitle="Neuro Wellness TMS Centers of America is located in Coral Springs, Florida, offering TMS, SAINT®, SPRAVATO®, and ketamine treatment for depression. We serve patients from across Broward, Miami-Dade, and Palm Beach counties — and many who travel from out of state."
    sections={[
      {
        heading: "Our Coral Springs Location",
        variant: "text",
        body: (
          <p>
            Our treatment center is located at 9734 West Sample Road, 2nd Floor
            - Suite B, Coral Springs, FL 33065. Coral Springs is in northern
            Broward County, conveniently accessible from surrounding communities
            throughout South Florida.
          </p>
        ),
      },
      {
        heading: "Treatments Available",
        variant: "cards",
        cards: [
          {
            title: "Traditional TMS",
            body: "FDA-cleared magnetic stimulation for treatment-resistant depression.",
          },
          {
            title: "SAINT® Accelerated TMS",
            body: "fMRI-guided, five-day accelerated TMS protocol.",
          },
          {
            title: "SPRAVATO® (Esketamine)",
            body: "FDA-approved nasal spray for treatment-resistant depression.",
          },
          {
            title: "IV Ketamine",
            body: "IV ketamine infusions and ketamine-assisted psychotherapy.",
          },
          {
            title: "Psychotherapy",
            body: "CBT, DBT, EMDR, and other therapeutic approaches.",
          },
          {
            title: "Medication Management",
            body: "Psychiatric medication oversight and coordination.",
          },
        ],
      },
      {
        heading: "Why Patients Choose Our Coral Springs Center",
        variant: "text",
        body: (
          <p>
            As the only Verified SAINT® Provider in Florida, we offer treatments
            that aren't available everywhere. Many patients travel to our Coral
            Springs location from across the state and beyond because of the
            range of options we provide and our experience with accelerated
            protocols.
          </p>
        ),
      },
      {
        heading: "Serving South Florida",
        variant: "text",
        body: (
          <p>
            We serve patients from Coral Springs, Parkland, Boca Raton, Coconut
            Creek, Fort Lauderdale, Pompano Beach, and communities throughout
            Broward, Miami-Dade, and Palm Beach counties. For patients traveling
            from out of state, we can discuss travel and accommodation
            arrangements.
          </p>
        ),
      },
      {
        heading: "Getting Here",
        variant: "text",
        body: (
          <p>
            Our office is located on West Sample Road in Coral Springs. For
            patients traveling by air, Fort Lauderdale-Hollywood International
            Airport is the nearest major airport. We can provide directions and
            travel guidance during your consultation.
          </p>
        ),
      },
    ]}
    faq={[
      {
        question: "Do you only treat patients from Coral Springs?",
        answer:
          "No. We serve patients from throughout South Florida and beyond. Many of our patients travel from out of state for treatment.",
      },
      {
        question: "Where are you located?",
        answer:
          "Our treatment center is at 9734 West Sample Road, 2nd Floor - Suite B, Coral Springs, FL 33065, in northern Broward County.",
      },
      {
        question: "Is parking available?",
        answer:
          "Yes, parking is available at our Coral Springs location. We can provide specific directions and parking information when you schedule your visit.",
      },
    ]}
    relatedLinks={[
      ...allTmsByConditionLinks.filter(
        (l) => l.href !== "/tms-coral-springs-fl",
      ),
      {
        title: "Depression Treatment Options",
        href: "/depression-treatment-options",
      },
      { title: "Traveling for Treatment", href: "/traveling-for-treatment" },
      { title: "TMS in Boca Raton", href: "/tms-boca-raton" },
      { title: "TMS in Fort Lauderdale", href: "/tms-fort-lauderdale" },
      { title: "TMS in Parkland", href: "/tms-parkland-fl" },
      { title: "TMS in Coconut Creek", href: "/tms-coconut-creek" },
    ]}
    finalCtaText="Located in Coral Springs and serving all of South Florida. Call our team to schedule a consultation."
  />
);

export default TmsCoralSpringsFl;
